import type { BreadcrumbItem, ContentItem } from "../types";

export function contentItemToBreadcrumb ( content: ContentItem ): BreadcrumbItem {
  return {
    id: content.id,
    name: content.name,
    url: content.route.path,
  };
}
